// src/config/teamCoins.js
// Catalogue des « coins » (espaces de travail délégables) + presets d'onboarding.
// Un admin voit tous les coins ; un membre team ne voit que ceux présents dans
// profiles.team_coins (colonne protégée par le trigger anti-escalade).

import {
  Newspaper,
  PhoneCall,
  Clapperboard,
  Megaphone,
  Wallet,
  Handshake,
  Images,
} from "lucide-react";

export const COINS = [
  {
    key: "actualites",
    title: "Actualités / Éditorial",
    icon: Newspaper,
    accent: "amber",
    desc: "Newsletters, actualités IA + manuelles, validation galeries.",
    route: "/team/actualites",
    ready: true,
  },
  {
    key: "relances",
    title: "Relances clients",
    icon: PhoneCall,
    accent: "rose",
    desc: "Relances administratives (paiements, essais) et commerciales (leads CRM).",
    route: "/team/relances",
    ready: true,
  },
  {
    key: "demos",
    title: "Démos",
    icon: Clapperboard,
    accent: "blue",
    desc: "Parcours démo transport & assurance, comptes de démonstration.",
    route: "/team/demos",
    ready: true,
  },
  {
    key: "cmo",
    title: "Acquisition & CRM",
    icon: Megaphone,
    accent: "violet",
    desc: "Pipeline CRM, campagne email, packs offerts influenceurs.",
    route: "/admin/crm",
    ready: true,
  },
  {
    key: "cfo",
    title: "Finance & facturation",
    icon: Wallet,
    accent: "green",
    desc: "Abonnements, factures, incidents de paiement, facturation électronique.",
    route: "/admin/dashboard",
    ready: true,
  },
  {
    key: "partenaires",
    title: "Partenaires & assurance",
    icon: Handshake,
    accent: "slate",
    desc: "Contrats & événements facturables, demandes assurance, curatorial.",
    route: "/team/partenaires",
    ready: true,
  },
  {
    key: "galeries",
    title: "Galeries",
    icon: Images,
    accent: "rose",
    desc: "Suivi galeries, demandes de galeries, import maisons de vente.",
    route: "/team/galeries",
    ready: true,
  },
];

export const COIN_BY_KEY = Object.fromEntries(COINS.map((c) => [c.key, c]));

// Presets d'onboarding : attribuent plusieurs coins d'un clic.
export const PRESETS = [
  { key: "editorial", label: "Éditorial", coins: ["actualites"], desc: "Petites mains actualités (manuel + IA)." },
  { key: "commercial", label: "Commercial", coins: ["relances", "cmo"], desc: "Relances et suivi CRM." },
  { key: "finance", label: "Finance", coins: ["cfo"], desc: "Suivi facturation et abonnements." },
  { key: "support_demo", label: "Support démo", coins: ["demos"], desc: "Aide sur les démonstrations." },
  { key: "operations", label: "Opérations", coins: ["partenaires", "galeries"], desc: "Partenaires, assurance, galeries." },
];

// Résout les coins visibles pour un profil : un admin a tout, sinon la liste déléguée.
export function coinsForProfile(profile) {
  if (!profile) return [];
  if (profile.role === "admin") return COINS.map((c) => c.key);
  return Array.isArray(profile.team_coins) ? profile.team_coins : [];
}

// Un membre a-t-il accès à un coin ? (admin = toujours)
export function hasCoin(profile, key) {
  if (!profile) return false;
  if (profile.role === "admin") return true;
  return Array.isArray(profile.team_coins) && profile.team_coins.includes(key);
}
